import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Col, Input, Label, Row } from 'reactstrap';
import { Toggle } from 'components/Common/Toggle';
import { HelpText } from 'components/HelpText';

export const OrderTypeMainEdit = () => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const toggleCheckbox = field => {
    formik.setFieldValue(field, !formik.values[field]);
  };

  return (
    <>
      {/* Translation Fields */}
      <Row className="d-flex mt-3 flex-wrap">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">
            {t('orderTypes.translationEn')}
            <HelpText size="sm" noBackground hideIcon>
              English translation of the order type name
            </HelpText>
          </Label>
        </Col>
        <Col xs={12} xl={8} className="p-0">
          <Input
            type="text"
            placeholder={t('orderTypes.translationEnPlaceholder')}
            name="translationEn"
            value={formik.values?.translationEn || ''}
            onChange={formik.handleChange}
            invalid={!!formik.errors.translationEn}
          />
          {formik.errors.translationEn && (
            <span className="text-danger small" style={{ fontSize: '11px' }}>
              {formik.errors.translationEn}
            </span>
          )}
        </Col>
      </Row>

      <Row className="d-flex mt-3 flex-wrap">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">
            {t('orderTypes.translationDe')}
            <HelpText size="sm" noBackground hideIcon>
              German translation of the order type name
            </HelpText>
          </Label>
        </Col>
        <Col xs={12} xl={8} className="p-0">
          <Input
            type="text"
            placeholder={t('orderTypes.translationDePlaceholder')}
            name="translationDe"
            value={formik.values?.translationDe || ''}
            onChange={formik.handleChange}
          />
        </Col>
      </Row>

      <Row id="clientSettings" className="d-flex mt-4 flex-wrap py-2">
        <Col
          xs={12}
          xl={4}
          className="p-0 d-flex align-items-center gap-3 py-1"
        >
          <Toggle
            checked={formik.values.isActive}
            onChange={() => toggleCheckbox('isActive')}
            label={t('orderTypes.isActive')}
          />
          <span className="text-muted small" style={{ fontSize: '11px' }}>
            Enable this order type
          </span>
        </Col>

        <Col
          xs={12}
          xl={4}
          className="p-0 d-flex align-items-center gap-3 py-1"
        >
          <Toggle
            checked={formik.values.enableForIndividual}
            onChange={() => toggleCheckbox('enableForIndividual')}
            label={t('orderTypes.enableForIndividual')}
          />
          <span className="text-muted small" style={{ fontSize: '11px' }}>
            Available for individual applicants
          </span>
        </Col>

        <Col
          xs={12}
          xl={4}
          className="p-0 d-flex align-items-center gap-3 py-1"
        >
          <Toggle
            checked={formik.values.enableForLegal}
            onChange={() => toggleCheckbox('enableForLegal')}
            label={t('orderTypes.enableForLegal')}
          />
          <span className="text-muted small" style={{ fontSize: '11px' }}>
            Available for legal entities
          </span>
        </Col>
      </Row>
    </>
  );
};
